import { createContext, useContext, useMemo } from 'react';

const SubnavContext = createContext<{ activeKey?: string }>({ activeKey: '' });

export const useSubnavContextProvider = (activeKey?: string) => useMemo(() => ({ activeKey }), [activeKey]);

export const useSubnavContext = () => useContext(SubnavContext);

/**
 * Used to create a context for a subnav to use. This is helpful so that
 * the Subnav.Item component can know which item is active.
 *
 * You do not need to use this directly, and it should only
 * ever be used by the Subnav component. As a consumer, all you need to
 * do is manage the activeKey state and pass it to the Subnav component.
 */
export default SubnavContext.Provider;
